<template>
  <div class="StlDialogContent" @contextmenu="handleMouseDown">
    <div id="ImplantPreView3D"></div>
    <!-- 模型精度条调整 -->
    <div class="ModelAdjustment">
      <div
        v-for="item in sliderData"
        v-show="item.mesh != null"
        :key="item.type"
        class="sliderbox"
      >
        <i :class="item.iconClass"></i>
        <div>
          <el-slider
            :min="0"
            :max="1"
            :step="0.01"
            v-model="item.sliderValue"
            @input="changeSliderValue(item)"
          />
        </div>
        <i
          class="eyeOn"
          @click="showModelPart(item)"
          v-show="item.eyeState"
        ></i>
        <i
          class="eyeClose"
          @click="showModelPart(item)"
          v-show="!item.eyeState"
        ></i>
      </div>
    </div>
    <!-- 工具栏 -->
    <div class="fullScreenTool">
      <tipIcom
        iconClass="icon48"
        :tip="fullScreenShow ? $t('Cancel Full Screen') : $t('Full Screen')"
        :url="
          fullScreenShow
            ? '/image/home/noFullScreen.png'
            : '/image/home/fullScreen.png'
        "
        @click="fullScreen"
      ></tipIcom>
    </div>
    <div class="toolbar">
      <el-dropdown popper-class="viewPopper" trigger="click" @command="handleCommand" @visible-change="handleDropdownVisible">
        <span class="six-view-primary-btn" @click="handlePrimaryClick">
          <tipIcom
            :tipShow="false"
            iconClass="icon48"
            :url="
              isPrimaryActive
                ? '/image/home/ASixViews.png'
                : '/image/home/SixViews.png'
            "
          ></tipIcom>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="1">
              <tipIcom
                iconClass="icon48"
                :tip="$t('Anterior View')"
                :url="
                  ActiveCube == '1'
                    ? '/image/home/ASixViews1.png'
                    : '/image/home/SixViews1.png'
                "
              ></tipIcom
            ></el-dropdown-item>
            <img class="custom-spacer" src="/image/home/Line .png" />
            <el-dropdown-item command="2">
              <tipIcom
                iconClass="icon48"
                :tip="$t('Posterior View')"
                :url="
                  ActiveCube == '2'
                    ? '/image/home/ASixViews2.png'
                    : '/image/home/SixViews2.png'
                "
              ></tipIcom
            ></el-dropdown-item>
            <img class="custom-spacer" src="/image/home/Line .png" />
            <el-dropdown-item command="3">
              <tipIcom
                iconClass="icon48"
                :tip="$t('Left View')"
                :url="
                  ActiveCube == '3'
                    ? '/image/home/ASixViews3.png'
                    : '/image/home/SixViews3.png'
                "
              ></tipIcom
            ></el-dropdown-item>
            <img class="custom-spacer" src="/image/home/Line .png" />
            <el-dropdown-item command="4">
              <tipIcom
                iconClass="icon48"
                :tip="$t('Right View')"
                :url="
                  ActiveCube == '4'
                    ? '/image/home/ASixViews4.png'
                    : '/image/home/SixViews4.png'
                "
              ></tipIcom
            ></el-dropdown-item>
            <img class="custom-spacer" src="/image/home/Line .png" />
            <el-dropdown-item command="5">
              <tipIcom
                iconClass="icon48"
                :tip="$t('Head View')"
                :url="
                  ActiveCube == '5'
                    ? '/image/home/ASixViews5.png'
                    : '/image/home/SixViews5.png'
                "
              ></tipIcom
            ></el-dropdown-item>
            <img class="custom-spacer" src="/image/home/Line .png" />
            <el-dropdown-item command="6">
              <tipIcom
                iconClass="icon48"
                :tip="$t('Foot View')"
                :url="
                  ActiveCube == '6'
                    ? '/image/home/ASixViews6.png'
                    : '/image/home/SixViews6.png'
                "
              ></tipIcom
            ></el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <tipIcom
        iconClass="icon48"
        :tip="$t('Reset View')"
        url="/image/home/resetView.png"
        @click="resetView"
      ></tipIcom>
      <tipIcom
        iconClass="icon48"
        :tip="$t('Switch True Color')"
        :url="
          isGrayScale
            ? '/image/home/DisableRendering.png'
            : '/image/home/EnableRendering.png'
        "
        @click="toggleGrayScale"
      ></tipIcom>
    </div>
  </div>
</template>

<script setup>
import {
  Scene,
  OrthographicCamera,
  WebGLRenderer,
  AmbientLight,
  PointLight,
  MeshStandardMaterial,
  Mesh,
  Box3,
  Color,
  Vector3,
  AxesHelper,
  DoubleSide,
  Group,
} from "three";
import { ArcballControls } from "three/examples/jsm/controls/ArcballControls";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { PLYLoader } from "three/examples/jsm/loaders/PLYLoader";
import { PublicStore } from "@/tools/pinia/store";
import { reactive, ref } from "vue";
const props = defineProps({
  modelUrlArr: {
    type: Array,
    default: {},
  },
});

let publicData = PublicStore();
// 禁止冒泡和去除鼠标右键默认菜单
function handleMouseDown(event) {
  event.stopPropagation();
  event.preventDefault();
}
// 滑块调整逻辑处理
let sliderData = reactive([
  {
    group: "base",
    pos: "up",
    type: "maxilla",
    iconClass: "maxillaIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "base",
    pos: "low",
    type: "mandible",
    iconClass: "mandibleIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "implant",
    pos: "up",
    type: "maxillaryImplant",
    iconClass: "maxillaryImplantIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "implant",
    pos: "low",
    type: "mandibularImplant",
    iconClass: "mandibularImplantIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "orthodontic",
    pos: "up",
    type: "UpperJawPreparation",
    iconClass: "UpperJawPreparationIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "orthodontic",
    pos: "low",
    type: "LowerJawPreparation",
    iconClass: "LowerJawPreparationIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "bite",
    pos: "1",
    type: "leftOcclusion",
    iconClass: "leftOcclusionIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },
  {
    group: "bite",
    pos: "2",
    type: "RightOcclusion",
    iconClass: "RightOcclusionIcon",
    sliderValue: 1,
    eyeState: false,
    mesh: null,
  },

]);
function hideModelPart(target) {
  if (!target.mesh) return;
  if (target.sliderValue !== 0) {
    target.previousSliderValue = target.sliderValue;
  }
  target.eyeState = false;
  target.sliderValue = 0;
  target.mesh.visible = false;
  if (target.mesh.material) {
    target.mesh.material.opacity = 0;
  }
}
function showModelPart(item) {
  if (item.eyeState) {
    hideModelPart(item);
  } else {
    switch (item.group) {
      case "base":
        sliderData.forEach((innerItem) => {
          if (
            innerItem.group == "bite" &&
            innerItem.mesh != null &&
            (innerItem.pos == "1" || innerItem.pos == "2")
          ) {
            hideModelPart(innerItem);
          }
        });
        break;
      case "implant":
        sliderData.forEach((innerItem) => {
          if (
            innerItem.mesh != null &&
            ((innerItem.group == "bite" &&
              (innerItem.pos == "1" || innerItem.pos == "2")) ||
              innerItem.group == "orthodontic")
          ) {
            hideModelPart(innerItem);
          }
        });
        break;
      case "bite":
        // 显示咬合模型时，隐藏所有非咬合组的模型
        sliderData.forEach((innerItem) => {
          if (innerItem.group != "bite" && innerItem.mesh != null) {
            hideModelPart(innerItem);
          }
        });
        // 如果显示的是 pos == "1"，隐藏 pos == "2"
        if (item.group == "bite" && item.pos == "1" && item.mesh != null) {
          sliderData.forEach((innerItem) => {
            if (innerItem.group == "bite" && innerItem.pos == "2" && innerItem.mesh != null) {
              hideModelPart(innerItem);
            }
          });
        } else if (
          item.group == "bite" &&
          item.pos == "2" &&
          item.mesh != null
        ) {
          // 如果显示的是 pos == "2"，隐藏 pos == "1"
          sliderData.forEach((innerItem) => {
            if (innerItem.group == "bite" && innerItem.pos == "1" && innerItem.mesh != null) {
              hideModelPart(innerItem);
            }
          });
        }
        break;
      case "orthodontic":
        sliderData.forEach((innerItem) => {
          if (
            innerItem.mesh != null &&
            ((innerItem.group == "bite" &&
              (innerItem.pos == "1" || innerItem.pos == "2")) ||
              innerItem.group == "implant")
          ) {
            hideModelPart(innerItem);
          }
        });
        break;
    }
    const hasPrevValue =
      typeof item.previousSliderValue === "number" &&
      item.previousSliderValue > 0;
    const restoreValue =
      item.sliderValue === 0
        ? hasPrevValue
          ? item.previousSliderValue
          : 1
        : item.sliderValue;
    item.sliderValue = restoreValue;
    if (restoreValue > 0) {
      item.previousSliderValue = restoreValue;
    } else {
      item.previousSliderValue = undefined;
    }
    if (item.mesh && item.mesh.material) {
      // 检查是否有其他 mesh 共享同一个材质引用
      let isMaterialShared = false;
      sliderData.forEach((otherItem) => {
        if (otherItem !== item && otherItem.mesh && otherItem.mesh.material === item.mesh.material) {
          isMaterialShared = true;
        }
      });
      
      // 如果材质被共享，创建新的独立材质实例
      if (isMaterialShared) {
        const newMaterial = item.mesh.material.clone();
        newMaterial.opacity = restoreValue;
        newMaterial.depthWrite = restoreValue >= 1.0;
        item.mesh.material = newMaterial;
        item.mesh.material.needsUpdate = true;
      } else {
        item.mesh.material.opacity = restoreValue;
        item.mesh.material.depthWrite = restoreValue >= 1.0;
      }
    }
    item.eyeState = true;
    item.mesh.visible = true;
  }
  render();
}
function changeSliderValue(item) {
  if (item.mesh && item.mesh.material) {
    // 检查是否有其他 mesh 共享同一个材质引用
    let isMaterialShared = false;
    sliderData.forEach((otherItem) => {
      if (otherItem !== item && otherItem.mesh && otherItem.mesh.material === item.mesh.material) {
        isMaterialShared = true;
      }
    });
    
    // 如果材质被共享，创建新的独立材质实例
    if (isMaterialShared) {
      const newMaterial = item.mesh.material.clone();
      newMaterial.opacity = item.sliderValue;
      // 修复透明度渲染问题：当透明度小于1时，禁用深度写入以避免重叠问题
      newMaterial.depthWrite = item.sliderValue >= 1.0;
      item.mesh.material = newMaterial;
      item.mesh.material.needsUpdate = true;
    } else {
      item.mesh.material.opacity = item.sliderValue;
      // 修复透明度渲染问题
      item.mesh.material.depthWrite = item.sliderValue >= 1.0;
    }
    // 当滑块值为0时，设置为闭眼（隐藏）
    if (item.sliderValue === 0) {
      item.eyeState = false;
      item.mesh.visible = false;
      item.previousSliderValue = undefined;
    } else {
      // 当滑块值不为0时，设置为睁眼（显示）
      item.eyeState = true;
      item.mesh.visible = true;
      item.previousSliderValue = item.sliderValue;
      
      // 如果是咬合组，隐藏所有非咬合组的模型
      if (item.group == "bite") {
        sliderData.forEach((innerItem) => {
          if (innerItem.group != "bite" && innerItem.mesh != null) {
            hideModelPart(innerItem);
          }
        });
        // 如果显示的是 pos == "1"，隐藏 pos == "2"
        if (item.pos == "1") {
          sliderData.forEach((innerItem) => {
            if (innerItem.group == "bite" && innerItem.pos == "2" && innerItem.mesh != null) {
              hideModelPart(innerItem);
            }
          });
        } else if (item.pos == "2") {
          // 如果显示的是 pos == "2"，隐藏 pos == "1"
          sliderData.forEach((innerItem) => {
            if (innerItem.group == "bite" && innerItem.pos == "1" && innerItem.mesh != null) {
              hideModelPart(innerItem);
            }
          });
        }
      }
    }
  }
  render();
}
// canvas场景
let scene = null;
let camera = null;
let frustumSize = 120; //可视区域的大小
let renderer = null;
let controls = null;
let pointLight = null;
let ambientLight = null;
let groupMap = {};
// 初始化场景、相机、灯光等
onMounted(() => {
  nextTick(() => {
    const element = document.getElementById("ImplantPreView3D");
    const parentElement = element.parentElement;
    const width = parentElement.offsetWidth;
    const height = parentElement.offsetHeight;
    // 定义正交相机参数
    const aspectRatio = width / height;
    // 创建主场景
    scene = new Scene();
    camera = new OrthographicCamera(
      (-frustumSize * aspectRatio) / 2, // left
      (frustumSize * aspectRatio) / 2, // right
      frustumSize / 2, // top
      -frustumSize / 2, // bottom
      0.1, // near
      1000 // far
    );
    camera.position.set(0, 0, 50); // 调整位置以适应
    camera.lookAt(0, 0, 0);

    ambientLight = new AmbientLight(0xffffff, 1);
    pointLight = new PointLight(0xffffff, 0.8, 100);
    pointLight.castShadow = true;

    // 设置点光源的位置
    pointLight.position.set(
      camera.position.x,
      camera.position.y,
      camera.position.z
    );
    scene.add(pointLight);
    scene.add(ambientLight);

    renderer = new WebGLRenderer({
      antialias: true,
      powerPreference: "high-performance",
    });
    renderer.setSize(width, height);
    renderer.setClearColor(0xf0f3f6, 1);
    renderer.shadowMap.enabled = true;
    renderer.setPixelRatio(1);

    controls = new ArcballControls(camera, renderer.domElement);
    // 设置鼠标操作
    controls.unsetMouseAction(2, null);
    // controls.unsetMouseAction("WHEEL", null);
    controls.minZoom = 0.4;
    controls.maxZoom = 2;

    let isDragging = false;
    let downControl = false;
    // 监听 ArcballControls 的 change 事件
    controls.addEventListener("change", (event) => {
      renderer.domElement.classList.remove("cursorMove");
      renderer.domElement.classList.remove("cursorFlip");
      // 在 change 事件中根据鼠标状态来判断操作类型
      if (isDragging && !downControl) {
        // 正在旋转
        renderer.domElement.classList.add("cursorFlip");
      } else if (downControl && isDragging) {
        // 默认状态
        renderer.domElement.classList.add("cursorMove");
      }

      // 更新光源位置并渲染场景
      pointLight.position.copy(camera.position);
      // camera.lookAt(0, 0, 0);
      render();
    });

    renderer.domElement.tabIndex = 0;
    renderer.domElement.focus();
    renderer.domElement.style.outline = "none";
    // 监听鼠标按下事件
    renderer.domElement.addEventListener("mousedown", (event) => {
      isDragging = true;
    });

    // 监听鼠标抬起事件
    renderer.domElement.addEventListener("mouseup", (event) => {
      isDragging = false;
      // 默认状态
      renderer.domElement.classList.remove("cursorMove");
      renderer.domElement.classList.remove("cursorFlip");
      isDragging = false;
      downControl = false;
    });
    renderer.domElement.addEventListener("keydown", (event) => {
      if (event.key == "Control") {
        downControl = true;
      }
    });
    renderer.domElement.addEventListener("keyup", (event) => {
      if (event.key == "Control") {
        downControl = false;
      }
    });

    // 监听鼠标移动事件
    renderer.domElement.addEventListener("mousemove", (event) => {
      if (isDragging) {
        isDragging = true;
      }
    });

    let timeoutId;
    renderer.domElement.addEventListener("wheel", (event) => {
      clearTimeout(timeoutId); // 清除之前的定时器

      renderer.domElement.classList.add("cursorZoom-in");
      timeoutId = setTimeout(() => {
        renderer.domElement.classList.remove("cursorZoom-in");
      }, 200);
    });

    // 创建坐标轴辅助线
    // const axesHelper = new AxesHelper(50); // 参数为坐标轴长度
    // scene.add(axesHelper);

    element.appendChild(renderer.domElement);
    newGroup();
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeRender);
});
function newGroup() {
  // 创建组
  groupMap = new Group();
  // 给组取一个名字
  let modelPromises = props.modelUrlArr.map((item) => {
    let lastDotIndex = item.src.lastIndexOf(".");
    let afterDot = item.src.slice(lastDotIndex + 1);
    switch (afterDot) {
      case "ply":
        return plyModel(item); // 返回 Promise
      case "stl":
        return stlModel(item); // 返回 Promise
      default:
        return Promise.resolve(); // 处理未知格式
    }
  });
  // 使用 Promise.all 等待所有模型加载完成
  Promise.all(modelPromises).then(() => {
    // 遍历 Group 中的所有对象
    groupMap.children.forEach((object) => {
      let index = sliderData.findIndex(
        (item) => item.group == object.kind && item.pos == object.name
      );

      if (index != -1) {
        sliderData[index].mesh = object;
      }
    });
    sliderData.forEach((item) => {
      if (item.mesh != null) {
        item.mesh.visible = false;
        item.eyeState = false;
        item.sliderValue = 0;
        if (item.mesh.material) {
          item.mesh.material.opacity = 0;
        }
      }
      if (item.group == "base" && item.mesh != null) {
        item.mesh.visible = true;
        item.eyeState = true;
        item.sliderValue = 1;
        if (item.mesh.material) {
          item.mesh.material.opacity = 1;
        }
      }
    });
    render();
    // 先适配模型到视口（设置 controls.target 为模型中心）
    fitCameraToObject(groupMap);
    // 然后设置默认前视图
    handleCommand("1");
    publicData.changeLoadingShow(false);
    // 所有模型加载完成后执行渲染逻辑
    console.log("所有模型加载完成，开始渲染");
  });
  scene.add(groupMap);
}

function stlModel(item) {
  const loader = new STLLoader();
  return loadModel(import.meta.env.VITE_APP_OSSURL + item.src).then(
    (arrayBuffer) => {
      const stl = loader.parse(arrayBuffer);
      // 解析 STL 模型文件
      const material = new MeshStandardMaterial({
        //材质定义
        roughness: 0.3,
        side: DoubleSide,
        vertexColors: true, // 使用顶点颜色
        transparent: true, // 启用透明度
        opacity: 1.0, // 初始设置为完全不透明
        emissive: 0xffffff, // 设置自发光颜色为白色
        emissiveIntensity: 0.2, // 设置自发光强度
        depthWrite: true, // 初始时启用深度写入（完全不透明时）
        depthTest: true, // 启用深度测试
      });
      const stlMesh = new Mesh(stl, material);
      stlMesh.name = item.pos; // 设置名字
      stlMesh.kind = item.kind; // 设置名字
      stlMesh.geometry.computeVertexNormals();
      groupMap.add(stlMesh);
    }
  );
}

// 解析 PLY 模型文件
function plyModel(item) {
  const loader = new PLYLoader();
  return loadModel(import.meta.env.VITE_APP_OSSURL + item.src).then(
    (arrayBuffer) => {
      const ply = loader.parse(arrayBuffer);
      // 解析 STL 模型文件
      const material = new MeshStandardMaterial({
        //材质定义
        roughness: 0.3,
        side: DoubleSide,
        vertexColors: true, // 使用顶点颜色
        transparent: true, // 启用透明度
        opacity: 1.0, // 初始设置为完全不透明.
        emissive: 0xffffff, // 设置自发光颜色为白色
        emissiveIntensity: 0.2, // 设置自发光强度
        depthWrite: true, // 初始时启用深度写入（完全不透明时）
        depthTest: true, // 启用深度测试
      });
      const mesh = new Mesh(ply, material);
      // mesh.scale.set(0.001, 0.001, 0.001);
      // mesh.geometry.computeVertexNormals();

      mesh.name = item.pos; // 设置名字
      mesh.kind = item.kind; // 设置名字
      groupMap.add(mesh);
    }
  );
}

// 计算模型边界框并调整相机位置
function fitCameraToObject(object) {
  const boundingBox = new Box3().setFromObject(object);
  const center = boundingBox.getCenter(new Vector3());
  const size = boundingBox.getSize(new Vector3());

  const maxSize = Math.max(
    boundingBox.max.x,
    boundingBox.max.y,
    boundingBox.max.z
  );
  const cameraDistance = maxSize * 2;
  camera.position.copy(center).add(new Vector3(0, 0, cameraDistance));
  camera.lookAt(center);

  controls.target.copy(center); // 更新 ArcballControls 的目标
  controls.update(); // 更新控制器

  pointLight.position.set(
    camera.position.x,
    camera.position.y,
    camera.position.z
  );
  render();
}

// 渲染更新
function render() {
  renderer.setViewport(
    0,
    0,
    renderer.domElement.width,
    renderer.domElement.height
  );
  renderer.setScissor(
    0,
    0,
    renderer.domElement.width,
    renderer.domElement.height
  );
  // renderer.setScissorTest(false);
  renderer.render(scene, camera);
}

// 调整窗口大小时更新渲染视图
function resizeRender() {
  const element = document.getElementById("ImplantPreView3D");
  const parentElement = element.parentElement;
  const width = parentElement.offsetWidth;
  const height = parentElement.offsetHeight;
  // 计算新的纵横比
  const aspectRatio = width / height;

  // 更新相机参数
  camera.left = (-frustumSize * aspectRatio) / 2;
  camera.right = (frustumSize * aspectRatio) / 2;
  camera.top = frustumSize / 2;
  camera.bottom = -frustumSize / 2;

  renderer.setSize(width, height);
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
  render(); // 确保在调整大小后重新渲染场景
}

window.addEventListener("resize", resizeRender);

// 工具函数
// 重置视图
function resetView() {
  // 重置为前视图（Anterior View）
  handleCommand("1");
}

// 真彩模式
let isGrayScale = ref(false); // 用于跟踪灰度模式的状态
function toggleGrayScale() {
  isGrayScale.value = !isGrayScale.value;

  if (isGrayScale.value) {
    // 灰度模式：禁用顶点颜色
    scene.traverse((object) => {
      if (object.isMesh) {
        // 确保对象有材质并且材质支持顶点颜色
        if (object.material && object.material.vertexColors !== undefined) {
          // 禁用顶点颜色
          object.material.vertexColors = false;
          object.material.color.set(0x808080); // 如果没有保存的颜色，设置为灰色
          // 重新计算法线，确保材质能正确响应灯光
          object.geometry.computeVertexNormals();
          object.material.needsUpdate = true; // 需要更新材质
        }
      }
    });

    if (pointLight && camera) {
      pointLight.position.copy(camera.position);
    }
  } else {
    // 切换回真彩模式：遍历 sliderData 确保使用正确的透明度值
    // 预先检测材质共享情况，避免重复检测（性能优化）
    const materialMap = new Map(); // 材质 -> 使用该材质的 mesh 列表
    
    sliderData.forEach((item) => {
      if (item.mesh && item.mesh.material) {
        const material = item.mesh.material;
        if (!materialMap.has(material)) {
          materialMap.set(material, []);
        }
        materialMap.get(material).push(item);
      }
    });
    
    // 批量更新材质
    sliderData.forEach((item) => {
      if (item.mesh && item.mesh.isMesh) {
        if (item.mesh.material && item.mesh.material.vertexColors !== undefined) {
          // 获取正确的透明度值（优先使用 sliderValue）
          const targetOpacity = typeof item.sliderValue === 'number' && item.sliderValue >= 0 && item.sliderValue <= 1
            ? item.sliderValue
            : (item.mesh.material.opacity || 1.0);
          
          // 检查材质是否被共享（使用预先构建的 map）
          const sharedMeshes = materialMap.get(item.mesh.material);
          const isMaterialShared = sharedMeshes && sharedMeshes.length > 1;
          
          if (isMaterialShared) {
            // 材质被共享，需要创建新材质
            const newMaterial = new MeshStandardMaterial({
              roughness: 0.3,
              side: DoubleSide,
              vertexColors: true,
              transparent: true,
              opacity: targetOpacity,
              emissive: 0xffffff,
              emissiveIntensity: 0.2,
              depthWrite: targetOpacity >= 1.0,
              depthTest: true,
            });
            item.mesh.material = newMaterial;
            item.mesh.material.needsUpdate = true;
          } else {
            // 材质独立，直接修改属性（更快）
            item.mesh.material.vertexColors = true;
            item.mesh.material.opacity = targetOpacity;
            item.mesh.material.depthWrite = targetOpacity >= 1.0;
            if (item.mesh.userData.originalColor) {
              item.mesh.material.color.copy(item.mesh.userData.originalColor);
            } else {
              item.mesh.material.color.set(0xffffff);
            }
            item.mesh.material.needsUpdate = true;
          }
        }
      }
    });
  }
  render(); // 切换灰度模式后重新渲染场景
}

// 观察面选择
let ActiveCube = ref("");
let blinkTimer = null;
let isPrimaryActive = ref(false);

// 一级主按钮点击事件
function handlePrimaryClick() {
  isPrimaryActive.value = true;
}

// 下拉菜单显示/隐藏事件
function handleDropdownVisible(visible) {
  // 菜单关闭但没选择二级按钮时，恢复一级按钮状态
  if (!visible && isPrimaryActive.value) {
    // 给一个小延迟，如果是点击了二级按钮会在handleCommand中重置
    setTimeout(() => {
      if (isPrimaryActive.value) {
        isPrimaryActive.value = false;
      }
    }, 50);
  }
}

function handleCommand(value) {
  // 二级按钮被点击，恢复一级按钮状态
  isPrimaryActive.value = false;

  // 触发二级按钮闪烁效果
  ActiveCube.value = value;
  if (blinkTimer) clearTimeout(blinkTimer);
  blinkTimer = setTimeout(() => {
    ActiveCube.value = "";
  }, 300);

  // 获取模型中心点
  let center = new Vector3(0, 0, 0);
  if (groupMap && groupMap.children.length > 0) {
    const boundingBox = new Box3().setFromObject(groupMap);
    center = boundingBox.getCenter(new Vector3());
  }

  switch (value) {
    case "1":
      // 前视图（Anterior View）
      controls.reset();
      // 相机位置在Z轴负方向，使Z轴线朝外（远离观察者）
      camera.position.set(center.x, center.y, center.z - 50);
      camera.lookAt(center);
      controls.target.copy(center);
      // 设置点光源的位置
      pointLight.position.set(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      controls.update();
      render();
      break;
    case "2":
      // 后视图（Posterior View）
      controls.reset();
      // 相机位置在Z轴正方向，使Z轴线朝向观察者（朝内）
      camera.position.set(center.x, center.y, center.z + 50);
      camera.lookAt(center);
      controls.target.copy(center);
      // 设置点光源的位置
      pointLight.position.set(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      controls.update();
      render();
      break;
    case "3":
      // 左视图（Left View）
      controls.reset();
      // 相机位置在X轴负方向
      camera.position.set(center.x - 50, center.y, center.z);
      // 调整相机的up向量为Y轴正方向，使绿线在上边
      camera.up.set(0, 1, 0);
      camera.lookAt(center);
      // 绕世界坐标的Z轴旋转180度，使红线向外延伸，蓝线在右边
      camera.rotateOnWorldAxis(new Vector3(0, 0, 1), Math.PI);
      controls.target.copy(center);
      // 设置点光源的位置
      pointLight.position.set(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      controls.update();
      render();
      break;
    case "4":
      // 右视图（Right View）
      controls.reset();
      // 相机位置在X轴正方向
      camera.position.set(center.x + 50, center.y, center.z);
      // 调整相机的up向量为Y轴正方向，使绿线在上边
      camera.up.set(0, 1, 0);
      camera.lookAt(center);
      // 不旋转，使蓝线在左边，绿线在上边，红线向外延伸
      controls.target.copy(center);
      // 设置点光源的位置
      pointLight.position.set(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      controls.update();
      render();

      break;
     case "5":
      // 顶视图（Head View / Top View）
      controls.reset();
      // 统计有多少个模型
      const totalModelsForTopView = sliderData.filter(item => item.mesh != null).length;

      // 根据模型类型决定显示或隐藏
      sliderData.forEach((item) => {
        if (item.mesh != null) {
          // 如果只有一个模型，保持显示
          if (totalModelsForTopView === 1) {
            item.mesh.visible = true;
            item.eyeState = true;
            item.sliderValue = 1;
            if (item.mesh.material) {
              item.mesh.material.opacity = 1;
            }
          } else {
            // 多个模型时，判断是否应该显示该模型（只显示下颌相关模型）
            const shouldShow =
              (item.group == "base" && item.pos == "low" && item.type == "mandible") ||
              (item.group == "implant" && item.pos == "low" && item.type == "mandibularImplant") ||
              (item.group == "orthodontic" && item.pos == "low" && item.type == "LowerJawPreparation");

            if (shouldShow) {
              // 显示该模型
              item.mesh.visible = true;
              item.eyeState = true;
              item.sliderValue = 1;
              if (item.mesh.material) {
                item.mesh.material.opacity = 1;
              }
            } else {
              // 隐藏该模型
              item.mesh.visible = false;
              item.eyeState = false;
              item.sliderValue = 0;
              if (item.mesh.material) {
                item.mesh.material.opacity = 0;
              }
            }
          }
        }
      });
      // 相机位置在Y轴正方向，然后通过旋转使Y轴向内延伸
      camera.position.set(center.x, center.y + 50, center.z);
      // 调整相机的up向量为Z轴正方向，使Z轴向上延伸
      camera.up.set(0, 0, 1);
      camera.lookAt(center);
      // 保持up向量为Z轴正方向
      // 绕世界坐标的Z轴旋转180度，使X轴向左延伸，Y轴向内延伸
      camera.rotateOnWorldAxis(new Vector3(0, 0, 1), Math.PI);
      controls.target.copy(center);
      // 设置点光源的位置
      pointLight.position.set(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      controls.update();
      render();
      break;
    case "6":
      // 底视图（Foot View / Bottom View）

      controls.reset();
      // 统计有多少个模型
      const totalModelsForBottomView = sliderData.filter(item => item.mesh != null).length;

      // 根据模型类型决定显示或隐藏
      sliderData.forEach((item) => {
        if (item.mesh != null) {
          // 如果只有一个模型，保持显示
          if (totalModelsForBottomView === 1) {
            item.mesh.visible = true;
            item.eyeState = true;
            item.sliderValue = 1;
            if (item.mesh.material) {
              item.mesh.material.opacity = 1;
            }
          } else {
            // 多个模型时，判断是否应该显示该模型（只显示上颌相关模型）
            const shouldShow =
              (item.group == "base" && item.pos == "up" && item.type == "maxilla") ||
              (item.group == "implant" && item.pos == "up" && item.type == "maxillaryImplant") ||
              (item.group == "orthodontic" && item.pos == "up" && item.type == "UpperJawPreparation");

            if (shouldShow) {
              // 显示该模型
              item.mesh.visible = true;
              item.eyeState = true;
              item.sliderValue = 1;
              if (item.mesh.material) {
                item.mesh.material.opacity = 1;
              }
            } else {
              // 隐藏该模型
              item.mesh.visible = false;
              item.eyeState = false;
              item.sliderValue = 0;
              if (item.mesh.material) {
                item.mesh.material.opacity = 0;
              }
            }
          }
        }
      });
      // 相机位置在Y轴负方向，使Y轴向内延伸（向着观察者）
      camera.position.set(center.x, center.y - 50, center.z);
      // 调整相机的up向量为负Z方向，使Z轴线向下延伸
      camera.up.set(0, 0, -1);
      camera.lookAt(center);
      // 保持up向量为负Z方向，不恢复默认值
      // 不旋转，保持默认方向，使X轴线向左延伸
      controls.target.copy(center);
      // 设置点光源的位置
      pointLight.position.set(
        camera.position.x,
        camera.position.y,
        camera.position.z
      );
      controls.update();
      render();

      break;
  }
}

// 全屏显示||恢复默认窗口大小
let fullScreenShow = ref(false);
function fullScreen() {
  if (!fullScreenShow.value) {
    const modelPreviewElement = document.querySelector(".ModelPreview");
    modelPreviewElement.classList.replace("ModelPreview", "FullModelPreview");
    const StlDialogContentElement = document.querySelector(".StlDialogContent");
    StlDialogContentElement.classList.replace(
      "StlDialogContent",
      "FullStlDialogContent"
    );
    const viewPopperElement = document.querySelector(".viewPopper");
    viewPopperElement.classList.replace("viewPopper", "FullviewPopper");
    fullScreenShow.value = true;
  } else {
    const modelPreviewElement = document.querySelector(".FullModelPreview");
    modelPreviewElement.classList.replace("FullModelPreview", "ModelPreview");
    const StlDialogContentElement = document.querySelector(
      ".FullStlDialogContent"
    );
    StlDialogContentElement.classList.replace(
      "FullStlDialogContent",
      "StlDialogContent"
    );
    const viewPopperElement = document.querySelector(".FullviewPopper");
    viewPopperElement.classList.replace("FullviewPopper", "viewPopper");
    fullScreenShow.value = false;
  }
  resizeRender();
  // background: #6F9C2980;
}
</script>
<style lang="scss">
.six-view-primary-btn {
  display: inline-block;
  cursor: pointer;
}
.StlDialogContent {
  width: 100%;
  height: 800px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.FullStlDialogContent {
  width: 100%;
  height: 100vh;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.viewPopper {
  position: absolute !important;
  width: 344px;
  height: 64px !important;
  top: 150px !important;
  left: 1200px !important;
  box-shadow: 3px 3px 12px 0px #13141540;
  border-radius: 8px;
  .el-dropdown__list {
    height: 64px !important;
  }
  .el-dropdown-menu {
    width: 100%;
    height: 64px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between;
    padding: 0 8px 0 8px !important;
    box-sizing: border-box;
    .el-dropdown-menu__item {
      height: 48px;
      padding: 0 !important;
    }
  }
  .el-popper__arrow {
    display: none;
  }
}
.FullviewPopper {
  position: absolute !important;
  width: 344px;
  height: 64px !important;
  top: 92px !important;
  left: 1440px !important;
  box-shadow: 3px 3px 12px 0px #13141540;
  border-radius: 8px;
  .el-dropdown__list {
    height: 64px !important;
  }
  .el-dropdown-menu {
    width: 100%;
    height: 64px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between;
    padding: 0 8px 0 8px !important;
    box-sizing: border-box;
    .el-dropdown-menu__item {
      height: 48px;
      padding: 0 !important;
    }
  }
  .el-popper__arrow {
    display: none;
  }
}
// 鼠标样式
.cursorMove {
  cursor: url("/image/home/Move.png") 0 0, auto !important;
}
.cursorZoom-in {
  cursor: url("/image/home/zoom-in.png") 0 0, auto !important;
}
.cursorFlip {
  cursor: url("/image/home/flip.png") 0 0, auto !important;
}
</style>
<style scoped lang="scss">
#ImplantPreView3D {
  position: relative;
  width: 100%;
  height: 100%;
}
.ModelAdjustment {
  position: absolute;
  top: 32px;
  left: 32px;
  width: 252px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .sliderbox {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
      width: 140px;
    }
    .el-slider {
      .el-slider__runway {
        height: 4px;
      }
      .el-slider__bar {
        height: 4px;
      }
    }

    .maxillaIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/maxilla.png");
      background-size: cover;
    }
    .mandibleIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/mandible.png");
      background-size: cover;
    }
    .maxillaryImplantIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/maxillaryImplant.png");
      background-size: cover;
    }
    .mandibularImplantIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/mandibularImplant.png");
      background-size: cover;
    }
    .leftOcclusionIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/leftOcclusion.png");
      background-size: cover;
    }
    .RightOcclusionIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/RightOcclusion.png");
      background-size: cover;
    }
    .UpperJawPreparationIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/UpperJawPreparation.png");
      background-size: cover;
    }
    .LowerJawPreparationIcon {
      width: 48px;
      height: 48px;
      display: block;
      background: url("/image/home/LowerJawPreparation.png");
      background-size: cover;
    }
    .eyeOn {
      width: 40px;
      height: 40px;
      display: block;
      background: url("/image/home/eyeOn.png");
      background-size: cover;
    }
    .eyeClose {
      width: 40px;
      height: 40px;
      display: block;
      background: url("/image/home/eyeClose.png");
      background-size: cover;
    }
  }
}
.fullScreenTool {
  position: absolute !important;
  top: 35px;
  right: 200px;
}
.toolbar {
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  // gap: 10px;
  width: 176px;
  height: 64px;
  background: #fff;
  display: flex;
  align-items: center;
  border-radius: 8px;
  box-shadow: 4px 4px 16px 0px #13141540;
  justify-content: space-around;
  button {
    background-color: #e0bd00;
    border: none;
    color: white;
    padding: 10px;
    cursor: pointer;
    border-radius: 5px;
  }

  button:hover {
    background-color: #c0a000;
  }
}
</style>
